import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { Stack, useRouter, usePathname } from "@-/com.npmjs.expo-router";
import { Pressable, View } from "@-/com.npmjs.react-native";
import { SafeAreaView } from "@-/com.npmjs.react-native-safe-area-context";
import { withUniwind } from "@-/com.npmjs.uniwind";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { KeyboardAvoidingView } from "@-/com.npmjs.react-native-keyboard-controller";
import { useAuthPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.auth.navigator";

const AuthSafeAreaView = withUniwind(SafeAreaView);
const AuthKeyboardAvoidingView = withUniwind(KeyboardAvoidingView);

export function AuthLayout() {
  const [isEdgeNavigationEnabled] = useDeviceSetting("isEdgeNavigationEnabled");
  const router = useRouter();
  const pathname = usePathname();
  const authPageNavigator = useAuthPageNavigator();
  const isWelcome = pathname === "/auth";
  return (
    <AuthSafeAreaView className="flex-1 bg-background" edges={isWelcome ? [] : ["top", "bottom"]}>
      {/* The welcome galaxy has no fields of its own (the auth sheet over it avoids the keyboard
          itself), and must keep its full size: squashing it would shift the galaxy, and the entry
          dive draws its canvas over the welcome page at the same size. */}
      <AuthKeyboardAvoidingView behavior="padding" className="flex-1" enabled={!isWelcome}>
        {!isWelcome ? (
          <View className="flex-row items-center py-2">
            <Pressable
              accessibilityLabel="Back"
              accessibilityRole="button"
              className="size-11 shrink-0 items-start justify-center pl-2.25 active:opacity-70"
              onPress={() => {
                if (router.canGoBack()) {
                  router.back();
                } else {
                  authPageNavigator.replaceImmediately.mutate();
                }
              }}
              testID="auth-header-back"
            >
              <Icon className="text-foreground" name="FiChevronLeftBold" size={24} />
            </Pressable>
          </View>
        ) : null}
        <View className="relative flex-1">
          <Stack
            screenOptions={{
              animation: "none",
              animationMatchesGesture: false,
              fullScreenGestureEnabled: false,
              gestureEnabled: isEdgeNavigationEnabled,
              headerShown: false,
              keyboardHandlingEnabled: false,
            }}
          />
        </View>
      </AuthKeyboardAvoidingView>
    </AuthSafeAreaView>
  );
}
